import script from "./DjLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./DjLinks.vue?vue&type=script&setup=true&lang=js"

import "./DjLinks.vue?vue&type=style&index=0&id=4de8742a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4de8742a"]])

export default __exports__